import { cn } from '../../lib/cn';

export const avatars = [
  ['query-architect', 'معمار کوئری', '🧠'], ['index-scout', 'ردیاب ایندکس', '🔍'],
  ['join-smith', 'استاد جوین', '🔗'], ['window-navigator', 'ناوبر پنجره', '🧭'],
  ['data-sentinel', 'نگهبان داده', '🛡️'], ['cte-pilot', 'خلبان CTE', '✈️'],
  ['null-hunter', 'شکارچی NULL', '🎯'], ['schema-cartographer', 'نقشه‌کش شِما', '🗺️'],
  ['aggregate-forger', 'سازنده تجمیع', '🧮'], ['execution-analyst', 'تحلیلگر اجرا', '📈'],
  ['transaction-keeper', 'پاسبان تراکنش', '🔐'], ['rank-strategist', 'استراتژیست رتبه', '🏆'],
  ['data-detective', 'کارآگاه داده', '🕵️'], ['metric-builder', 'سازنده متریک', '📊'],
  ['query-runner', 'دونده کوئری', '🏃'], ['logic-lab', 'آزمایشگاه منطق', '🧪'],
  ['dashboard-maker', 'داشبوردساز', '🖥️'], ['bug-squasher', 'باگ‌کوب', '🛠️'],
  ['insight-miner', 'معدن‌کار بینش', '⛏️'], ['optimizer-owl', 'جغد بهینه‌ساز', '🦉'],
] as const;

export const teamColors = ['#2563FF', '#5B3DF5', '#28D7FF', '#14B8A6', '#22C55E', '#F8B931', '#A855F7', '#06B6D4', '#EF4444', '#0F172A'] as const;

export function TeamAvatar({ avatarId, color, className }: { avatarId: string; color: string; className?: string }) {
  const avatar = avatars.find(([id]) => id === avatarId) ?? avatars[0];
  return (
    <div
      className={cn('relative grid size-12 shrink-0 place-items-center overflow-hidden rounded-[16px] text-[1.55rem] leading-none shadow-lg', className)}
      style={{ background: `linear-gradient(145deg, ${color}, ${color}bb)` }}
      title={avatar[1]}
      aria-label={avatar[1]}
    >
      <span className="absolute inset-x-2 top-2 h-px bg-white/35" />
      <span className="absolute inset-x-2 bottom-2 h-px bg-black/15" />
      <span className="absolute inset-0 bg-[radial-gradient(circle_at_35%_25%,rgba(255,255,255,.28),transparent_34%)]" />
      <span className="relative drop-shadow-sm" dir="ltr">{avatar[2]}</span>
    </div>
  );
}
